import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setTimestamp
} from '../redux/personalDates'

export default function * requestChangePersonalDate (action) {
  const { id, timestamp } = action.payload

  const state = yield select()

  const currentPersonalDate = state.kanbo.personalDates.byId[id]

  if (!currentPersonalDate) return

  const optimisticAction = yield optimisticPut(setTimestamp({
    id,
    timestamp
  }))

  try {
    yield call(apiAction, 'SetPersonalDate', {
      id,
      timestamp
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
